export default {
  data() {
    return {
      active: false,
      activeTimeout: null,
      isOpen: false,
      isClosing: false,
      pageContent: null,
      dragging: false,
      dragStartPos: 0,
      dragDiff: 0,
      dragThreshold: 75,
    }
  },
  methods: {
    open() {
      clearTimeout(this.activeTimeout);
      this.active = true;
      this.pageContent.style = null;
      setTimeout(() => {
        this.isOpen = true;
      }, 50);
      document.body.classList.add('stop-scroll');
    },
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.isClosing = true;
      this.activeTimeout = setTimeout(() => {
        this.isClosing = false;
        this.active = false;
      }, 500);
      document.body.classList.remove('stop-scroll');
    },
    translateY(pos) {
      return 'translate(-50%,' + pos + 'px)';
    },
  },
  mounted() {
    this.pageContent = this.$el.querySelector('.page-overlay-container');

    let isScrolling = false;

    const dragStart = e => {
      this.dragDiff = 0;
      this.dragStartPos = e.touches ? e.touches[0].clientY : e.clientY;
    };

    const dragMove = e => {
      e.preventDefault();

      this.dragDiff = (e.touches ? e.touches[0].clientY : e.clientY) - this.dragStartPos;

      if (this.dragDiff > 0) {
        this.dragging = true;
        this.pageContent.style.transform = this.translateY(this.dragDiff);
      } else {
        this.pageContent.style.transform = this.translateY(0);
      }
    };
    const dragEnd = e => {
      this.dragging = false;
      this.pageContent.style.transform = null;
      isScrolling = false;

      // Handle drag arrow click (drag diff less than 10)
      if (this.dragDiff < 10) {
        if (e.target.classList.value.includes('drag-arrow')) this.close();
        return;
      }

      if (this.dragDiff < this.dragThreshold) return;

      this.close();
    };

    const mouseMoveHandler = e => {
      if (this.pageContent.scrollTop > 0) {
        isScrolling = true;
        return;
      }

      if (isScrolling) return;
      dragMove(e);
    };

    // Touch events
    this.pageContent.addEventListener('touchstart', e => {
      dragStart(e);
      this.pageContent.addEventListener('touchmove', mouseMoveHandler);
    });
    this.pageContent.addEventListener('touchend', e => {
      dragEnd(e);
      this.pageContent.removeEventListener('touchmove', mouseMoveHandler);
    });

    // Mouse events
    this.pageContent.addEventListener('mousedown', e => {
      dragStart(e);
      this.pageContent.addEventListener('mousemove', mouseMoveHandler);
    });
    this.pageContent.addEventListener('mouseup', e => {
      dragEnd(e);
      this.pageContent.removeEventListener('mousemove', mouseMoveHandler);
    });
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PageOverlay.js